export const INITIALIZE_OPERATOR_PAGE = 'initialize-operator-page';
const initializeOperatorPage = () => ({ type: INITIALIZE_OPERATOR_PAGE });
export default initializeOperatorPage;
